<mp-agreement-info-list class="contract-agreement-cell" [agreementBaseInfo]="agreement()" />
<mp-graduations class="contract-agreement-cell" [graduations]="agreementGraduations()" [showEffectColumn]="true" />
